import Actions from "../Types";
import responseHandler from "../../utils/responseHandler";
import Instance from "../../utils/api";
import Storage from "../../utils/storage";

// SEARCH STAFF LIST
export const searchStaffStart = () => ({
    type: Actions.SEARCH_STAFF_START
});

export const searchStaffSuccess = payload => ({
    type: Actions.SEARCH_STAFF_SUCCESS,
    payload
});

export const searchStaffFailure = payload => ({
    type: Actions.SEARCH_STAFF_FAILURE,
    payload
});


export const searchStaff = (search, limit, offset) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))
    
    dispatch(searchStaffStart());
    API.get(`staff?q=${search}&limit=${limit}&offset=${offset}`).then((response) => {
        const { data, ok } = response;
        responseHandler(response);
        if(ok){
            dispatch(searchStaffSuccess(data.data));
        }
        else {
            dispatch(searchStaffFailure(data));
        }
    })
};
